module.exports = __webpack_public_path__ + "static/ceelabs-b53f1f147807202b87b3da1081d2669e.png";